import { gql } from "@apollo/client";

export const DISTRO = gql`
  query Distro($distroId: String!) {
    distro(distroId: $distroId) {
      id
      adminOnly
      aliases
      arch
      authorizedKeysFile
      bootstrapSettings {
        clientDir
        communication
        containerIsolation {
          cpus
          enabled
          image
          memoryMb
          requireIsolation
        }
        env {
          key
          value
        }
        jasperBinaryDir
        jasperCredentialsPath
        method
        preconditionScripts {
          path
          script
        }
        resourceLimits {
          lockedMemoryKb
          numFiles
          numProcesses
          numTasks
          virtualMemoryKb
        }
        rootDir
        serviceUser
        shellPath
      }
      containerPool
      costData {
        onDemandRate
        savingsPlanRate
      }
      disabled
      disableShallowClone
      dispatcherSettings {
        version
      }
      execUser
      expansions {
        key
        value
      }
      finderSettings {
        version
      }
      homeVolumeSettings {
        formatCommand
      }
      hostAllocatorSettings {
        acceptableHostIdleTime
        autoTuneMaximumHosts
        feedbackRule
        futureHostFraction
        hostsOverallocatedRule
        maximumHosts
        minimumHosts
        roundingRule
        version
      }
      iceCreamSettings {
        configPath
        schedulerHost
      }
      imageId
      isCluster
      isVirtualWorkStation
      mountpoints
      name
      note
      plannerSettings {
        commitQueueFactor
        expectedRuntimeFactor
        generateTaskFactor
        groupVersions
        mainlineTimeInQueueFactor
        mergeQueueTargetTime
        numDependentsFactor
        patchFactor
        patchTimeInQueueFactor
        targetTime
        version
      }
      provider
      providerAccount
      providerSettingsList
      setup
      setupAsSudo
      singleTaskDistro
      sshOptions
      taskHostOverrides {
        doNotAssignPublicIpv4Address
        iamInstanceProfileArn
        providerAccount
        securityGroupIds
        subnetId
      }
      user
      userSpawnAllowed
      validProjects
      warningNote
      workDir
    }
  }
`;
